module.exports = __webpack_public_path__ + "img/cooperation-logo3.537964ae.png";